import registryJson from 'command-palette-registry';

import type {NavigationItem} from './types';

export const NAVIGATION_REGISTRY: NavigationItem[] = registryJson.navigation as NavigationItem[];
